import { createContext, useContext } from 'react';

import type { useCanvasOnlyActionCardIds } from './useCanvasActionCardPlacements';

export type CanvasActionCardPlacements = ReturnType<
  typeof useCanvasOnlyActionCardIds
>;

const EMPTY_CANVAS_ACTION_CARD_PLACEMENTS: CanvasActionCardPlacements = {
  canvasOnlyLocalIds: new Set(),
  isLoading: false,
};

export const CanvasActionCardPlacementContext =
  createContext<CanvasActionCardPlacements | null>(null);

export const useCanvasActionCardPlacements = () =>
  useContext(CanvasActionCardPlacementContext) ??
  EMPTY_CANVAS_ACTION_CARD_PLACEMENTS;
